import React, { useState, useEffect, useRef } from 'react'
import { shape, string, object, array, arrayOf } from 'prop-types'
import { Table } from '../../dpe-usco'
import TableTabs from '../subComponents/TableTabs'
import TableInput from '../../dpe-usco/components/Table/TableInput/TableInput'

const findTab = (tabs, tabValue) => {
  const tabFilt = tabs.filter(tab => {
    return tab.value === tabValue
  })
  return tabFilt
}
const TabbedTable = ({ tabs, initialTab, currentTabCallback, editMode, statusComponent, updateRowData, IsInputTable, bottomOfTable,  setPremiumType, premiumType, subRowStructure, showPremiumToggle, grainReceivers }) => {
  const [currentTab, setCurrentTab] = useState( initialTab ? findTab(tabs, initialTab)[0] : { ...tabs[0] })
  const clickTab = tab => {
    setCurrentTab(tab)
    if (currentTabCallback) {
      currentTabCallback(tab)
    }
  }

  let tableRender = IsInputTable ? (
    <TableInput
      type={currentTab.value}
      editMode={editMode}
      structure={currentTab.structure}
      data={currentTab.data}
      statusComponent={statusComponent}
      updateRowData={updateRowData}
    />
  ) : (
    <Table
      subRowStructure={subRowStructure}
      structure={currentTab.structure}
      data={currentTab.data}
      onScrollAPI={currentTab.onScrollAPI}
      statusComponent={statusComponent}
      bottomOfTable={currentTab.bottomOfTable || bottomOfTable}
      dropdownCallback={currentTab.structure.dropdownCallback}
      handleClick={currentTab.structure.handleClick}
      rowKey={currentTab.structure.rowKey}
      grainReceivers={grainReceivers}
    />
  )

  const prevInitialTab = useRef()

  useEffect(()=> {
    if(prevInitialTab.current !== initialTab){
      const newTab = findTab(tabs, initialTab)[0]
      if (currentTabCallback) {
        currentTabCallback(newTab)
      }
      setCurrentTab(newTab)
    } else{
      setCurrentTab(prev => {
        const newTab = findTab(tabs, prev.value)[0]
        if (currentTabCallback) {
          currentTabCallback(newTab)
        }
        return newTab
      })
    }
  }, [
    tabs, initialTab, currentTabCallback
  ])

  useEffect(()=> {
    if(prevInitialTab.current !== initialTab){
      prevInitialTab.current = initialTab
    }
  }, [initialTab])

  return (
    <div data-testid='tabTable'>
      <TableTabs
        showPremiumToggle={showPremiumToggle}
        premiumType={premiumType}
        setPremiumType={setPremiumType}
        tabs={tabs}
        callBack={clickTab}
        current={currentTab.value}
      />
      {tableRender}
    </div>
  )
}

export default TabbedTable

TabbedTable.propTypes = {
  tabs: arrayOf(
    shape({
      value: string, //The string in the tab
      structure: object, //The table structure object
      data: array //The table data
    })
  ),
  initialTab: string // The tab to start on
}
